<template>
  <div id="app">
    <a href="#main-content" class="skip-link">Ir al contenido principal</a>
    <NavBar1
      :isUserLogged="isLogged"
      :user="user"
      :itemsInCart="itemsInCart"
    ></NavBar1>
    <div id="main-content" tabindex="-1">
      <router-view></router-view>
    </div>
    <!--    <IndexOffers></IndexOffers>-->
    <Footer1></Footer1>
    <Footer2></Footer2>
  </div>
</template>

<script setup lang="ts">
import Footer2 from "./components/shared/Footer2.vue";
import Footer1 from "./components/shared/Footer1.vue";
import NavBar1 from "./components/shared/NavBar1.vue";
import { computed, onMounted } from "vue";
import { useAuthStore } from "./stores/authStore";
import { useCartStore } from "./stores/cartStore";
import { storageService } from "./utils/storageService";
import { toast } from "vue3-toastify";
import {
  markReleaseNoticeSeen,
  shouldShowReleaseNotice,
} from "./utils/releaseNotice";

const authStore = useAuthStore();
const cartStore = useCartStore();

function buildPersistedUser(): Record<string, unknown> | null {
  const persisted =
    storageService.getJson<Record<string, unknown>>("usuarioObjeto") ?? {};
  if (Object.keys(persisted).length) {
    return persisted;
  }
  const partial = {
    name: storageService.getItem("nombre") ?? "",
    userid: storageService.getItem("userid") ?? "",
    clienteId: storageService.getItem("cliente") ?? "",
  };
  return Object.values(partial).some(Boolean) ? partial : null;
}

const user = computed(() => authStore.user ?? buildPersistedUser());
const itemsInCart = computed(() => cartStore.count);
const isLogged = computed(
  () => Boolean(user.value) || storageService.getToken() != null,
);

onMounted(() => {
  cartStore.refresh();
  if (shouldShowReleaseNotice()) {
    toast.info(
      "¡Nueva versión disponible! Ya está disponible una versión actualizada con mejoras.",
      {
        autoClose: 30000,
      },
    );
    markReleaseNoticeSeen();
  }
});
</script>

<style>
.skip-link {
  position: absolute;
  top: -100%;
  left: 0;
  z-index: 10000;
  padding: 8px 16px;
  background: var(--color-primary);
  color: #fff;
  font-size: 14px;
  text-decoration: none;
}
.skip-link:focus {
  top: 0;
}
</style>
